module.exports = __webpack_public_path__ + "static/media/partitions_gwp_60yd_n.a10d6401.csv";